import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-calendar/es/index.js
// module id = 287
// module chunks = 0